export const formatTime = (date: Date): string => {
  return date.toLocaleTimeString('en-GB', {
    minute: '2-digit',
    hour: '2-digit',
  });
};
